import React from 'react'
import useMediaQuery from 'hec/hooks/useMediaQuery'
import {useMediaQueryWithBuilder} from 'hec/builder/hooks/useMediaQueryWithBuilder'
import {TextBlock} from '@/components/text-block'
import {getHeroBgStyle} from '../utils'
import {IsingleColumnProps} from '../types'
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    ContentButtonNavigation
} from '@/components/ui/carousel'
//sry in advance for this monster of a component 😭
const SingleColumn = (props: IsingleColumnProps) => {
    const {isMobile: isBuilderMobile} = useMediaQueryWithBuilder()
    const isMobile = useMediaQuery('sm')
    const {
        backgroundType,
        backgroundImage,
        backgroundImageMobile,
        backgroundColor,
        backgroundGradient,
        contentPosition,
        contentPositionMobile,
        external,
        external_link,
        link,
        couponCode,
        enableCouponCode,
        eyebrowText,
        eyebrowIcon,
        eyebrowType,
        disclaimerText,
        headlineType,
        headlineImage,
        headlineText,
        textBlock,
        callToAction,
        buttonColor,
        buttonTextColor,
        enableOverlay,
        overlayColor,
        textAlignment,
        eyebrowBackgroundColor,
        eyebrowSize,
        eyebrowTextColor,
        carouselItems = [],
        carouselAutoplay,
        carouselAutoplayDelay,
        carouselDots,
        attributes
    } = props

    const bgStyle = getHeroBgStyle({
        backgroundType,
        backgroundImage,
        backgroundImageMobile,
        backgroundColor,
        backgroundGradient,
        isMobile,
        isBuilderMobile
    })

    let alignItemsMd = 'center'
    if (contentPosition === 'left') alignItemsMd = 'flex-start'
    if (contentPosition === 'right') alignItemsMd = 'flex-end'

    let justifyContentMobile = 'center'
    if (contentPositionMobile === 'top') justifyContentMobile = 'flex-start'
    if (contentPositionMobile === 'bottom') justifyContentMobile = 'flex-end'

    const flexStyle: React.CSSProperties = {
        alignItems: 'center',
        justifyContent: justifyContentMobile,
        ['--align-items-md' as any]: alignItemsMd
    }

    const resolvedLink = external
        ? external_link?.value?.data?.url ?? ''
        : link?.value?.data?.url ?? ''
    return backgroundType === 'carousel' ? (
        <Carousel
            {...attributes}
            opts={{
                align: 'start',
                loop: true
            }}
            autoplay={carouselAutoplay}
            autoplayDelay={carouselAutoplayDelay || 4000}
            stopOnInteraction={true}
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            className={`w-full ${attributes?.className || ''}`}
        >
            <CarouselContent>
                {carouselItems.map((item, index) => {
                    const carouselBgStyle = getHeroBgStyle({
                        backgroundType: item.carouselBackgroundType || 'image',
                        backgroundImage: item.backgroundImage,
                        backgroundImageMobile: item.backgroundImageMobile,
                        backgroundColor: item.backgroundColor,
                        backgroundGradient: item.backgroundGradient,
                        isMobile,
                        isBuilderMobile
                    })

                    let carouselAlignItemsMd = 'center'
                    if (item.contentPosition === 'left') carouselAlignItemsMd = 'flex-start'
                    if (item.contentPosition === 'right') carouselAlignItemsMd = 'flex-end'

                    let carouselJustifyContentMobile = 'center'
                    if (item.contentPositionMobile === 'top')
                        carouselJustifyContentMobile = 'flex-start'
                    if (item.contentPositionMobile === 'bottom')
                        carouselJustifyContentMobile = 'flex-end'

                    const carouselFlexStyle: React.CSSProperties = {
                        alignItems: 'center',
                        justifyContent: carouselJustifyContentMobile,
                        ['--align-items-md' as any]: carouselAlignItemsMd
                    }

                    const carouselResolvedLink = item.external
                        ? item.external_link?.value?.data?.url ?? ''
                        : item.link?.value?.data?.url ?? ''

                    return (
                        <CarouselItem key={index}>
                            <section className="relative w-full" style={carouselBgStyle}>
                                <div className="hero hero-single-col relative mx-auto px-4">
                                    <div
                                        className="min-h-[400px] flex flex-col"
                                        style={carouselFlexStyle}
                                    >
                                        <style>{`
                                            @media (min-width: 992px) {
                                                [style*='--align-items-md'] {
                                                    align-items: var(--align-items-md) !important;
                                                    justify-content: center !important;
                                                }
                                            }
                                        `}</style>
                                        <div className="flex justify-center items-center max-w-[356px] lg:max-w-[650px] w-full">
                                            <TextBlock
                                                couponCode={item.couponCode}
                                                enableCouponCode={item.enableCouponCode}
                                                eyebrow={item.eyebrowText}
                                                eyebrowIcon={item.eyebrowIcon}
                                                eyebrowType={item.eyebrowType}
                                                disclaimer={
                                                    item.disclaimerText ? item.disclaimerText : ''
                                                }
                                                headlineType={item.headlineType}
                                                headlineImage={item.headlineImage}
                                                headline={
                                                    item.headlineText ? item.headlineText : ''
                                                }
                                                supportText={item.textBlock ? item.textBlock : ''}
                                                cta={item.callToAction ? item.callToAction : ''}
                                                buttonColor={item.buttonColor}
                                                buttonTextColor={item.buttonTextColor}
                                                external={item.external}
                                                link={carouselResolvedLink}
                                                overlay={item.enableOverlay}
                                                overlayColor={item.overlayColor}
                                                alignment={item.textAlignment}
                                                eyebrowBackgroundColor={item.eyebrowBackgroundColor}
                                                eyebrowSize={item.eyebrowSize}
                                                eyebrowTextColor={item.eyebrowTextColor}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </CarouselItem>
                    )
                })}
            </CarouselContent>
            {carouselItems.length > 1 && carouselDots !== false && (
                <ContentButtonNavigation
                    buttonType="circleButton"
                    data-testid={'homepage-hero-carousel'}
                />
            )}
        </Carousel>
    ) : (
        <section
            {...attributes}
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            className={`relative w-full ${attributes?.className || ''}`}
            style={bgStyle}
        >
            <div className="hero hero-single-col relative mx-auto mb-5 px-4">
                <div className="min-h-[400px] flex flex-col" style={flexStyle}>
                    <style>{`
                        @media (min-width: 992px) {
                            [style*='--align-items-md'] {
                                align-items: var(--align-items-md) !important;
                                justify-content: center !important;
                            }
                        }
                    `}</style>
                    <div className="flex justify-center items-center max-w-[356px]  lg:max-w-[650px]  w-full">
                        <TextBlock
                            couponCode={couponCode}
                            enableCouponCode={enableCouponCode}
                            eyebrow={eyebrowText}
                            eyebrowIcon={eyebrowIcon}
                            eyebrowType={eyebrowType}
                            disclaimer={disclaimerText ? disclaimerText : ''}
                            headlineType={headlineType}
                            headlineImage={headlineImage}
                            headline={headlineText ? headlineText : ''}
                            supportText={textBlock ? textBlock : ''}
                            cta={callToAction ? callToAction : ''}
                            buttonColor={buttonColor}
                            buttonTextColor={buttonTextColor}
                            external={external}
                            link={resolvedLink}
                            overlay={enableOverlay}
                            overlayColor={overlayColor}
                            alignment={textAlignment}
                            eyebrowBackgroundColor={eyebrowBackgroundColor}
                            eyebrowSize={eyebrowSize}
                            eyebrowTextColor={eyebrowTextColor}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SingleColumn
